/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Integrations_Application_IdInputs */



/**
* | output |
* | --- |
* | "Application ID" |
*
* @param {Options_Integrations_Application_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_integrations_application_id = /** @type {((inputs?: Options_Integrations_Application_IdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Integrations_Application_IdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ID d'application")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anwendungs-ID")
	if (locale === "it") return /** @type {LocalizedString} */ ("ID applicazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Идентификатор приложения")
	if (locale === "es") return /** @type {LocalizedString} */ ("ID de la aplicación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("应用程序 ID")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アプリケーションID")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आवेदन आईडी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("ID do aplicativo")
	return /** @type {LocalizedString} */ ("Application ID")
});